var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reseller-password-reset" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-center" }, [
        _c("div", { staticClass: "md:w-1/2 lg:w-5/12 w-full" }, [
          _c(
            "div",
            { staticClass: "lg:px-20" },
            [
              _c("div", { staticClass: "text-center" }, [
                _c("h1", { staticClass: "h4 mb-8" }, [
                  _vm._v(_vm._s(_vm.translations.reset_title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-40" }, [
                  _vm._v(_vm._s(_vm.translations.reset_description))
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "mb-24",
                  attrs: {
                    loading: _vm.loading,
                    success: _vm.success,
                    error: _vm.server_error,
                    "button-class":
                      "btn btn-green btn-lg btn-rounded w-full mt-8 font-bold",
                    "submit-text": _vm.translations.reset_button
                  },
                  on: { submit: _vm.submit }
                },
                [
                  _c("el-input", {
                    staticClass: "mb-16",
                    attrs: {
                      type: "password",
                      rules: {
                        required: true,
                        min: 8,
                        regex: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/
                      },
                      label: _vm.translations.password_field
                    },
                    model: {
                      value: _vm.formData.password,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "password", $$v)
                      },
                      expression: "formData.password"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "mb-16",
                    attrs: {
                      type: "password",
                      rules: {
                        required: true,
                        is: _vm.formData.password,
                        min: 8,
                        regex: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/
                      },
                      label: _vm.translations.password_repeat_field
                    },
                    model: {
                      value: _vm.repeatPassword,
                      callback: function($$v) {
                        _vm.repeatPassword = $$v
                      },
                      expression: "repeatPassword"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }